import * as React from 'react';
import { useState, useEffect } from "react";
import * as Yup from 'yup';
import FormikForm from '~/lib/forms/FormikForm';
import SaleHeader from './SaleHeader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import Button from '~/common/elements/mobile/Button';
import { buttonColor, buttonSize, buttonStyle } from '~/common/elements/mobile/consts';
import { getFilteredPaymentTypeNames } from '~/apps/pos/shared/services/helpers';


const saleSchema = Yup.object().shape({
  paymentType: Yup.string().typeError('Must select a payment type').required('Required'),
});

type Props = {
  initialValues: any,
  isDesktop: boolean,
  onBack: any,
  onHelp: any,
  onClose: any,
  onSubmit: any,
  setFormData: any,
  actionKeyBack: number,
  disablePaymentTypes: Array<string>,
}

const SaleStepPaid = (props: Props) => {
  const {
    initialValues, isDesktop, onBack, onHelp, onClose, onSubmit, setFormData, actionKeyBack, disablePaymentTypes,
  } = props;
  const [isInitialValid, setInitialValid] = useState(false);
  const [isSubmit, setSubmit] = useState(false);

  const handleHelp = onHelp ? () => { onHelp(actionKeyBack) } : null;

  const formOnSubmit = (data) => {
    setSubmit(true);
    if (setFormData) setFormData(data);
    return onSubmit(saleSchema.cast(data));
  };

  const renderButtons = (propsForm) => {
    const { values: { paymentType } } = propsForm;
    const setValue = (actionKey) => {
      const { setFieldValue } = propsForm;

      setFieldValue('paymentType', actionKey);
    };

    return (
      <div className="form--rows">
        <div className="m__body__tags">
          <div className="m__body__lbl">Select Payment Type</div>
          {
            getFilteredPaymentTypeNames(disablePaymentTypes)
              .map((i) => {
                return <Button
                  key={i.key}
                  title={i.name}
                  actionKey={i.key}
                  buttonStyle={buttonStyle.OUTL}
                  buttonSize={buttonSize.MD}
                  tagStyle
                  tagActive={paymentType === i.key}
                  onClick={(actionKey) => setValue(actionKey)}
                />
              })
          }
        </div>
      </div>
    )
  };

  useEffect(() => {
    saleSchema.isValid(initialValues).then(valid => {
      if (valid) setInitialValid(true)
    });
  }, []);

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={formOnSubmit}
      validationSchema={saleSchema}
      isInitialValid={isInitialValid}
      render={(propsForm) => {

        return (
          <PageMobileWrapper>
            <SaleHeader
              onBack={onBack}
              onHelp={!isDesktop ? handleHelp : null}
              onClose={onClose}
              title="Payment Option"
            />

            <BodyWrapper>
              <div className="m__body__titl">New Payment</div>
              <p className="m__body__info">Process a transaction in 60 seconds. <br />
                <a onClick={handleHelp} href="#" className="m__body__anch">Need assistance?</a></p>
                {renderButtons(propsForm)}
            </BodyWrapper>

            <FooterWrapper>
              <Button
                title={isSubmit ? 'Please Wait...' : propsForm.isValid ? 'Next' : 'Select Payment to Continue'}
                buttonStyle={isSubmit ? buttonStyle.SECN : propsForm.isValid ? buttonStyle.OUTL_LITE : buttonStyle.LARY}
                buttonSize={buttonSize.LG}
                buttonColor={propsForm.isValid ? buttonColor.PRIM : null}
                onClick={!isSubmit ? propsForm.submitForm : null}
              />
            </FooterWrapper>
          </PageMobileWrapper>
        );
      }}
    />
  );
};

export default SaleStepPaid;
